import { render, staticRenderFns } from "./unusualFilmRecord.vue?vue&type=template&id=9c63d8c6&scoped=true&"
import script from "./unusualFilmRecord.vue?vue&type=script&lang=js&"
export * from "./unusualFilmRecord.vue?vue&type=script&lang=js&"
import style1 from "./unusualFilmRecord.vue?vue&type=style&index=1&id=9c63d8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c63d8c6",
  null
  
)

export default component.exports